import { API_ENDPOINTS, getApiUrl, getAuthHeaders } from '../config/api';

export const userSettingsApi = {
  sendPhoneVerification: async (token: string) => {
    const response = await fetch(getApiUrl(API_ENDPOINTS.USER.VERIFY_PHONE), {
      method: 'POST',
      headers: getAuthHeaders(token),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `Failed to send phone verification (${response.status}: ${response.statusText})`);

    }
    return await response.json();
  },

  confirmPhoneVerification: async (token: string, otp: string) => {
    const response = await fetch(getApiUrl(API_ENDPOINTS.USER.VERIFY_PHONE_CONFIRM), {
      method: 'POST',
      headers: getAuthHeaders(token),
      body: JSON.stringify({ code: otp }),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `Failed to confirm phone verification (${response.status}: ${response.statusText})`);

    }
    return await response.json();
  },

  sendEmailVerification: async (token: string) => {
    const response = await fetch(getApiUrl(API_ENDPOINTS.USER.VERIFY_EMAIL), {
      method: 'POST',
      headers: getAuthHeaders(token),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `Failed to send email verification (${response.status}: ${response.statusText})`);

    }
    return await response.json();
  },

  confirmEmailVerification: async (token: string, otp: string) => {
    const response = await fetch(getApiUrl(API_ENDPOINTS.USER.VERIFY_EMAIL_CONFIRM), {
      method: 'POST',
      headers: getAuthHeaders(token),
      body: JSON.stringify({ code: otp }),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `Failed to confirm email verification (${response.status}: ${response.statusText})`);

    }
    return await response.json();
  },

  getNotificationPreferences: async (token: string) => {
    const response = await fetch(getApiUrl(API_ENDPOINTS.USER.NOTIFICATIONS), {
      method: 'GET',
      headers: getAuthHeaders(token),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `Failed to fetch notification preferences (${response.status}: ${response.statusText})`);

    }
    return await response.json();
  },

  updateNotificationPreferences: async (token: string, preferences: any) => {
    const response = await fetch(getApiUrl(API_ENDPOINTS.USER.NOTIFICATIONS), {
      method: 'PATCH',
      headers: getAuthHeaders(token),
      body: JSON.stringify(preferences),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `Failed to update notification preferences (${response.status}: ${response.statusText})`);

    }
    return await response.json();
  },
};
